var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iha-issue-page page-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "iha-issue_headercontainer d-flex align-items-end justify-content-between flex-wrap gap-2"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0)], 1), _c('div', {
    staticClass: "right-content"
  }, [_c('button', {
    staticClass: "univ-btn py-2 px-3 d-flex align-items-center gap-1 m-0",
    on: {
      "click": function click($event) {
        return _vm.openRaiseIhaIssueModal(null);
      }
    }
  }, [_c('span', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
    }
  })])]), _vm._v(" Add New Issue ")])])]), _c('div', {
    staticClass: "row iha-issue-card"
  }, [_c('div', {
    staticClass: "issue-tabs"
  }, [_c('div', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'all'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('all');
      }
    }
  }, [_vm._v(" All "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.stats.total_issues))])]), _c('div', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'pending'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('pending');
      }
    }
  }, [_vm._v(" Pending "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.stats.open_issues))])]), _c('div', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'progress'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('progress');
      }
    }
  }, [_vm._v(" In Progress "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.stats.in_progress_issues))])]), _c('div', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'resolved'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('resolved');
      }
    }
  }, [_vm._v(" Resolved "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.stats.closed_issues))])]), _c('div', {
    staticClass: "tab-item",
    class: {
      active: _vm.activeTab === 'withdrawn'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('withdrawn');
      }
    }
  }, [_vm._v(" Withdrawn "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.stats.withdrawn_issues))])])]), _c('div', {
    staticClass: "issue-filters"
  }, [_c('QuickFilterInput', {
    ref: "quickFilter",
    staticClass: "filter-search",
    attrs: {
      "labels": ['Member Name', 'Plan'],
      "placeholders": {
        'Member Name': 'Enter Member Name',
        Plan: 'Enter Plan Name'
      },
      "preserveInputOnLabelChange": true
    },
    on: {
      "search": _vm.handleQuickSearch
    }
  }), _c('QuickDropdownFilter', {
    attrs: {
      "label": "Issue Type",
      "options": _vm.issueTypeOptions,
      "model-value": _vm.issueType
    },
    on: {
      "update:modelValue": function updateModelValue($event) {
        _vm.issueType = $event;

        _vm.fetchIssues();
      }
    }
  }), _c('div', {
    staticClass: "date-range-wrapper"
  }, [_c('div', {
    staticClass: "fw-semibold"
  }, [_vm._v("Date:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.startDate,
      expression: "startDate"
    }],
    staticClass: "date-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.startDate
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value;
      }
    }
  })]), _c('button', {
    staticClass: "clear-btn d-flex align-items-center gap-1",
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('span', {
    staticClass: "icon-wrap d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z"
    }
  })])]), _vm._v(" Clear ")])], 1), _c('div', {
    staticClass: "top-pagination p-0"
  }, [_c('IhaPagination', {
    attrs: {
      "rows": _vm.rows
    },
    on: {
      "page-change": _vm.handlePageChange
    }
  })], 1), _c('div', {
    staticClass: "table-responsive p-0"
  }, [_c('table', {
    staticClass: "table issue-table"
  }, [_vm._m(1), _c('tbody', [_vm._l(_vm.filteredIssues, function (issue) {
    var _issue$member_details, _issue$member_details2, _issue$member_details3, _issue$plan_details;

    return _c('tr', {
      key: issue.id
    }, [_c('td', [_c('span', {
      staticClass: "status-badge-issue issue-type",
      class: issue.type
    }, [_vm._v(_vm._s(issue.type))])]), _c('td', [_c('div', {
      staticClass: "member-name fw-semibold"
    }, [_vm._v(_vm._s((_issue$member_details = issue.member_details) === null || _issue$member_details === void 0 ? void 0 : _issue$member_details.cfname) + " " + _vm._s((_issue$member_details2 = issue.member_details) === null || _issue$member_details2 === void 0 ? void 0 : _issue$member_details2.clname))]), _c('div', {
      staticClass: "member-email"
    }, [_vm._v(_vm._s((_issue$member_details3 = issue.member_details) === null || _issue$member_details3 === void 0 ? void 0 : _issue$member_details3.cemail))])]), _c('td', [_vm._v(_vm._s(((_issue$plan_details = issue.plan_details) === null || _issue$plan_details === void 0 ? void 0 : _issue$plan_details.web_display_name) || '-'))]), _c('td', [_c('div', {
      staticClass: "desc"
    }, [_vm._v(" " + _vm._s(issue.details) + " ")])]), _c('td', [_vm._v(_vm._s(_vm.formatDate(issue.created_at)))]), _c('td', [_c('div', {
      staticClass: "d-flex flex-column gap-2 align-items-start"
    }, [_c('span', {
      staticClass: "status-badge-issue",
      class: _vm.getIssueStatus(issue.status)
    }, [_vm._v(" " + _vm._s(_vm.getIssueStatus(issue.status)) + " ")]), _vm.getIssueStatus(issue.status) === 'pending' && issue.admin_seen_status ? _c('div', {
      staticClass: "viewed-by-iha status-badge-issue d-flex align-items-center gap-1"
    }, [_vm._m(2, true), _c('span', {
      staticClass: "ms-1"
    }, [_vm._v("Viewed by IHA")])]) : _vm._e()])]), _c('td', {
      staticClass: "action-icons"
    }, [_c('custom-button', {
      attrs: {
        "title": "View Details",
        "iconClass": "fas fa-info"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.viewDetail(issue.id);
        }
      }
    }), _vm.getIssueStatus(issue.status) === 'pending' ? _c('custom-button', {
      staticClass: "sign-incomplete",
      attrs: {
        "title": "Withdraw Issue",
        "iconClass": "fas fa-ban"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openWithdrawModal(issue);
        }
      }
    }) : _vm._e()], 1)]);
  }), _vm.isLoading ? _c('tr', [_vm._m(3)]) : _vm._e(), !_vm.isLoading && _vm.filteredIssues.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No issues found")])]) : _vm._e()], 2)])])])]), _c('AddIhaIssue', {
    attrs: {
      "isOpen": _vm.showRaiseIhaIssueModal,
      "row": _vm.row,
      "issue-types": _vm.issueTypes
    },
    on: {
      "close": function close($event) {
        _vm.showRaiseIhaIssueModal = false;
      },
      "created": function created($event) {
        _vm.fetchIssues();

        _vm.fetchStats();
      }
    }
  }), _vm.showWithdrawIssueModal ? _c('WithdrawIssueModal', {
    attrs: {
      "row": _vm.row
    },
    on: {
      "close": function close($event) {
        _vm.showWithdrawIssueModal = false;
      },
      "withdraw": _vm.handleWithdraw
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Securus Issue Center")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Issue Type")]), _c('th', [_vm._v("Member")]), _c('th', [_vm._v("Plan")]), _c('th', [_vm._v("Description")]), _c('th', [_vm._v("Submitted On")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Actions")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('i', {
    staticClass: "fas fa-eye"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "visually-hidden"
  }, [_vm._v("Loading...")])])]);
}]

export { render, staticRenderFns }